// src/components/MDXPost.js
import React from 'react';
import Content, {title, dateCreated, dateModified } from './content.mdx';
import WriteupLayout from '../components/WriteupLayout';

export default function PilotChessWriteup() {  
  return (
    <WriteupLayout title={title} dateCreated={dateCreated} dateModified={dateModified} githubLink={"https://github.com/timbslr/PilotChess-Automatic-Chess-Board"}>
      <Content/>
    </WriteupLayout>
  );
};